// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ad-event__form[data-v-6269085b] .v-input--is-disabled fieldset {\n  background-color: #E7E7E7;\n}\n.ad-event__form[data-v-6269085b] .v-input--is-disabled input {\n  color: var(--v-secondary-base);\n}", ""]);
// Exports
module.exports = exports;
